import variables from "../variables";
import {warn} from "./_utilities";
import {$style} from "./style";

export const $ui = (function () {

	const
		APIs = {},
		{set, remove} = $style
	;

	APIs.blockScroll = function (action, paddingRight = variables.scrollbarWidth) {
		switch (action) {
			case 'enable':
				set(document.body, {
					overflow: 'hidden',
					paddingRight: paddingRight + 'px'
				});
				break;
			case 'disable':
				remove(document.body, 'overflow, padding-right');
				break;
			default:
				warn('Missing argument in blockScroll function', '$ui-helper')
		}
	};


	return APIs;
})(window);
